module.exports = __webpack_public_path__ + "assets/img/61@3x.8a6e21c9.png";